export const openInUnityEditor = (packageId: string) => {
  const url = `com.unity3d.kharma:content/${packageId}`;
  window.open(url, '_blank');
};
